module.exports = __webpack_public_path__ + "static/assets/7268bcde4f92b7c54ee70401f4da11ff.png";